module.exports = __webpack_public_path__ + "img/Radio_Button_Empty_Black.f76b4a7b.svg";